module.exports = __webpack_public_path__ + "static/media/mdk.4ce10ecc.avif";